import script from "./VueCheckBoxFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueCheckBoxFilter.vue?vue&type=script&setup=true&lang=ts"

import "./VueCheckBoxFilter.vue?vue&type=style&index=0&id=59bab45d&lang=css"

const __exports__ = script;

export default __exports__